module.exports = __webpack_public_path__ + "media/coffee-preferences/acidity_medium-b4effc71.png";